import React,{createContext, ReactNode, useContext, useState} from "react";

interface UserDetailsContextType {
    isUserId: number;
    setIsUserId: React.Dispatch<React.SetStateAction<number>>;
    isUserFirstName: string;
    setIsUserFirstName: React.Dispatch<React.SetStateAction<string>>;
    isUserLastName: string;
    setIsUserLastName: React.Dispatch<React.SetStateAction<string>>;
    isUserName: string;
    setIsUserName: React.Dispatch<React.SetStateAction<string>>;
    isUserRole: string;
    setIsUserRole: React.Dispatch<React.SetStateAction<string>>;
    isUserImage: string;
    setIsUserImage: React.Dispatch<React.SetStateAction<string>>;
    isUserLocation: string;
    setIsUserLocation: React.Dispatch<React.SetStateAction<string>>;
    isUserMail: string;
    setIsUserMail: React.Dispatch<React.SetStateAction<string>>;
    isUserPhone: string;
    setIsUserPhone: React.Dispatch<React.SetStateAction<string>>;
}
const UserDetailContext = createContext<UserDetailsContextType | undefined>(undefined);

export const UserDetailProvider:React.FC <{children : ReactNode}> = ({children}) => {
    const [isUserId, setIsUserId] = useState<number>(0);
    const [isUserFirstName, setIsUserFirstName] = useState<string>("");
    const [isUserLastName, setIsUserLastName] = useState<string>("");
    const [isUserName, setIsUserName] = useState<string>("");
    const [isUserRole, setIsUserRole] = useState<string>("");
    const [isUserImage, setIsUserImage] = useState<string>("");
    const [isUserLocation, setIsUserLocation] = useState<string>("");
    const [isUserMail, setIsUserMail] = useState<string>("");
    const [isUserPhone, setIsUserPhone] = useState<string>("");

    const UserDetailsValue : UserDetailsContextType = { 
        isUserId , setIsUserId, isUserFirstName , setIsUserFirstName,isUserLastName , setIsUserLastName, isUserName , setIsUserName, isUserRole , setIsUserRole, isUserImage , setIsUserImage, isUserLocation , setIsUserLocation, isUserMail , setIsUserMail, isUserPhone , setIsUserPhone
    }
    
    return (
        <UserDetailContext.Provider value={UserDetailsValue}>{children} </UserDetailContext.Provider>
    );
};

export const useUser = () : UserDetailsContextType => {
    const userContext = useContext(UserDetailContext);
    if(!userContext){
        throw new Error('useContext must be used within a UserDetailsProvider');
    }
    return userContext;
}
